import { WidgetGetDto } from "clearline-api";

export type PixelTagData = Omit<PixelTag, "widget"> & { widgetId: number };

export class PixelTag {
  public id: number;
  public name: string;
  public tag: string;
  public locationId: number;
  public widget: WidgetGetDto;
  public isActive: boolean;
}

export interface IPixelTagData {}
